// ===========================================
// SCHEMA: EditarVencimiento
// ===========================================
// Schema Zod para el formulario de editar un vencimiento individual

import { z } from 'zod'

export const editarVencimientoSchema = z.object({
  fecha_vencimiento: z.string().min(1, 'La fecha de vencimiento es requerida'),
  monto_determinado: z
    .number()
    .min(-99999999, 'El monto no puede ser menor a -99.999.999')
    .max(99999999, 'El monto no puede ser mayor a 99.999.999')
    .nullable()
    .optional(),
  observaciones: z.string().nullable().optional(),
  motivo_prorroga: z.string().nullable().optional(),
})

export type EditarVencimientoFormValues = z.infer<typeof editarVencimientoSchema>
